/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "m11.893 5.807.113-.007a.9.9 0 0 1 .893.787l.007.113-.001 8.393 2.419-2.41a.905.905 0 0 1 1.09-.06l.096.076c.34.304.395.807.146 1.174l-.075.097-3.865 3.932a.904.904 0 0 1-1.255.087l-4.049-4.02a.898.898 0 0 1 .066-1.27.904.904 0 0 1 1.186-.02l2.441 2.368V6.7a.9.9 0 0 1 .788-.893l.113-.007-.113.007Z"
})), "0 0 24 24", "ArrowDown");